import React, { useState, useEffect } from "react";
import { Grid, Select, MenuItem, Input } from "@material-ui/core";
import { BarChart, Bar } from "recharts";
import { useAPI } from '../../../../hooks/useApi'

// styles
import useStyles from "./styles";

// components
import Widget from "../../../../components/Widget";
import { Typography } from "../../../../components/Wrappers";

export default function BigStat() {
  const { get } = useAPI();

  var classes = useStyles();
  const [data, setData] = useState({
    userNotLeave:"",
    featureLeave:"",
    userLeave:""
  })



  useEffect(() => {
    get("authorization/getStatistics").then((response) => {
      if (response.status === true) {
       setData(response)
      }
    })
  }, [])

  return (
   <>
    <Grid item direction="row" spacing={3}>
    <Widget
      header={
        <div className={classes.title}>
          <Typography variant="h5">Sigarayı Bırakan Kullanıcılar</Typography>

        </div>
      }
      upperTitle
      bodyClass={classes.bodyWidgetOverflow}
    >
      <div className={classes.totalValueContainer}>
        <div className={classes.totalValue}>
          <Typography size="xxl" color="text" colorBrightness="secondary">
            {data?.userLeave}
          </Typography>

        </div>
        <BarChart width={150} height={70} data={getRandomData()}>
          <Bar
            dataKey="value"
            fill={"#27BF60"}
            radius={10}
            barSize={10}
          />
        </BarChart>
      </div>

    </Widget>
    </Grid>
    <Grid item direction="row" >
    <Widget
      header={
        <div className={classes.title}>
          <Typography variant="h5">Sigarayı Bırakmayı Düşünen Kullanıcılar</Typography>

        </div>
      }
      upperTitle
      bodyClass={classes.bodyWidgetOverflow}
    >
      <div className={classes.totalValueContainer}>
        <div className={classes.totalValue}>
          <Typography size="xxl" color="text" colorBrightness="secondary">
            {data?.featureLeave}
          </Typography>

        </div>
        <BarChart width={150} height={70} data={getRandomData()}>
          <Bar
            dataKey="value"
            fill={"rgb(255, 194, 96)"}
            radius={10}
            barSize={10}
          />
        </BarChart>
      </div>

    </Widget>
    </Grid>
    <Grid item direction="row" >
    <Widget
      header={
        <div className={classes.title}>
          <Typography variant="h5">Sigarayı Bırakmayan Kullanıcılar</Typography>

        </div>
      }
      upperTitle
      bodyClass={classes.bodyWidgetOverflow}
    >
      <div className={classes.totalValueContainer}>
        <div className={classes.totalValue}>
          <Typography size="xxl" color="text" colorBrightness="secondary">
            {data?.userNotLeave}
          </Typography>

        </div>
        <BarChart width={150} height={70} data={getRandomData()}>
          <Bar
            dataKey="value"
            fill={"rgb(0, 0, 0)"}
            radius={10}
            barSize={10}
          />
        </BarChart>
      </div>

    </Widget>
    </Grid>
    </>
  );
}

// #######################################################################

function getRandomData() {
  return Array(7)
    .fill()
    .map(() => ({ value: Math.floor(Math.random() * 10) + 1 }));
}
